<div class="flex flex-col sm:w-30vw h-screen sm:h-auto max-h-screen" *transloco="let t; read: 'expression-settings'">
    <div class="flex flex-row items-center place-content-between p-4">
        <div class="flex flex-col space-y-2">
            <span class="text-3xl font-bold">{{ t("CONDITIONAL_SETTINGS_DIALOG_TITLE") }}</span>
        </div>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="flex flex-col space-y-4 p-4 h-full overflow-y-auto">
        <fuse-alert [type]="'info'" [appearance]="'outline'">
            {{ t("CONDITIONAL_SETTINGS_HINT") }}
        </fuse-alert>
        <div
            class="flex-flex-col space-y-4"
            cdkDropList
            [cdkDropListData]="formDefinition.conditionals"
            (cdkDropListDropped)="onDrop($event)"
        >
            <ng-container *ngFor="let conditional of formDefinition.conditionals">
                <div
                    class="flex items-center justify-between rounded border border-accent shadow-sm cursor-pointer hover:bg-accent-50 p-2"
                    (click)="edit(conditional)"
                    cdkDrag
                    [cdkDragData]="conditional"
                >
                    <div class="flex flex-row space-x-2 items-center">
                        <button mat-icon-button cdkDragHandle>
                            <mat-icon class="handle"> drag_handle </mat-icon>
                        </button>
                        <span>{{ conditional.name }}</span>
                    </div>
                    <div class="flex space-x-2 items-center">
                        <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="edit(conditional)">
                                <span>{{ t("ACTION_EDIT") }}</span>
                            </button>
                            <button mat-menu-item (click)="remove(conditional)">
                                <span>{{ t("ACTION_REMOVE") }}</span>
                            </button>
                        </mat-menu>
                    </div>
                    <div
                        *cdkDragPlaceholder
                        class="h-16 flex flex-row p-2 ring-1 ring-gray-100 rounded-sm bg-white"
                    ></div>
                </div>
            </ng-container>
        </div>

        <button mat-raised-button color="primary" (click)="add()">{{ t("ACTION_ADD_CONDITIONAL") }}</button>
    </div>
    <div class="flex flex-row items-center place-content-end m-4">
        <button mat-button mat-dialog-close>
            {{ t("ACTION_CLOSE") }}
        </button>
    </div>
</div>
